import Deferred from '@/utils/Deferred'

let deferred

export default {
  namespaced: true,
  state: {
    navigation_direction: 1,
    transition_promise: null,
    navigating: false,
    is_root_transition: false,
    active_tabbar_route: null
  },
  mutations: {
    SET_NAVIGATION_DIRECTION(state, direction) {
      state.navigation_direction = direction
    },
    SET_TRANSITION_PROMISE(state, promise) {
      state.transition_promise = promise
    },
    RESOLVE_TRANSITION_PROMISE(state) {
      if (!deferred) {
        return
      }
      deferred.resolve()
      deferred = null
      state.transition_promise = null
    },
    REJECT_TRANSITION_PROMISE(state) {
      if (!deferred) {
        return
      }
      deferred.reject()
      deferred = null
      state.transition_promise = null
    },
    SET_NAVIGATING(state, value) {
      state.navigating = value
    },
    SET_ROOT_TRANSITION(state, value) {
      state.is_root_transition = value
    },
    SET_ACTIVE_TABBAR_ROUTE(state, value) {
      state.active_tabbar_route = value
    }
  },
  actions: {
    SET_ACTIVE_TABBAR_ROUTE({ state, commit }, routeName) {
      if (state.active_tabbar_route !== routeName) {
        commit('SET_ACTIVE_TABBAR_ROUTE', routeName)
      }
    },
    SET_ROOT_TRANSITION({ state, commit }, isRootTransition) {
      if (state.is_root_transition !== isRootTransition) {
        commit('SET_ROOT_TRANSITION', isRootTransition)
      }
    },
    SET_NAVIGATING({ commit }, value) {
      commit('SET_NAVIGATING', value)
    },
    SET_NAVIGATION_DIRECTION({ state, commit }, direction) {
      if (!(direction === 1 || direction === -1)) {
        throw Error('Direction must be either 1 for forward or -1 for backwards')
      }
      if (state.navigation_direction !== direction) {
        commit('SET_NAVIGATION_DIRECTION', direction)
      }
    },
    CREATE_TRANSITION_PROMISE({ commit }) {
      deferred = new Deferred()

      commit('SET_TRANSITION_PROMISE', deferred.promise)

      return deferred.promise
    },
    RESOLVE_TRANSITION_PROMISE({ commit }) {
      commit('RESOLVE_TRANSITION_PROMISE')
    },
    REJECT_TRANSITION_PROMISE({ commit }) {
      commit('REJECT_TRANSITION_PROMISE')
    }
  },
  getters: {}
}
